import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import PasswordInput from "@/components/PasswordInput";

export default function ResetPassword() {
    const nav = useNavigate();
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        if (password.length < 8) { setErr("Password must be at least 8 characters."); return; }
        if (password !== confirm) { setErr("Passwords don't match."); return; }
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            setDone(true);
            setTimeout(() => nav("/login", { replace: true }), 2500);
        } catch (e2) {
            setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
        } finally {
            setBusy(false);
        }
    };

    if (!token) {
        return (
            <AuthShell title="Invalid reset link" subtitle="This link is missing the security token.">
                <Link data-testid="reset-back-btn" className="bm-btn bm-btn-primary" to="/forgot-password" style={{ width: "100%", textAlign: "center", padding: "12px 16px" }}>
                    Request a new link
                </Link>
            </AuthShell>
        );
    }

    return (
        <AuthShell
            title={done ? "Password updated" : "Set a new password"}
            subtitle={done ? "Taking you to sign in…" : "Choose a new password (8+ characters)."}
        >
            {done ? (
                <div data-testid="reset-success" style={{ textAlign: "center", color: "var(--bm-good)" }}>
                    ⚓ All set. Redirecting to sign in…
                </div>
            ) : (
                <form onSubmit={submit} data-testid="reset-form">
                    <div style={{ marginBottom: 14 }}>
                        <label className="bm-label">New password</label>
                        <PasswordInput
                            data-testid="reset-password-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="new-password"
                            minLength={8}
                            required
                        />
                    </div>
                    <div style={{ marginBottom: 18 }}>
                        <label className="bm-label">Confirm password</label>
                        <PasswordInput
                            data-testid="reset-confirm-input"
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            autoComplete="new-password"
                            minLength={8}
                            required
                        />
                    </div>
                    {err && <div data-testid="reset-error" style={{ marginBottom: 14, color: "var(--bm-bad)", fontSize: 13 }}>{err}</div>}
                    <button
                        data-testid="reset-submit-btn"
                        type="submit"
                        disabled={busy}
                        className="bm-btn bm-btn-primary"
                        style={{ width: "100%", padding: "12px 16px", opacity: busy ? 0.6 : 1 }}
                    >
                        {busy ? "Saving…" : "Update password"}
                    </button>
                </form>
            )}
        </AuthShell>
    );
}
